import { render, staticRenderFns } from "./Salidas.vue?vue&type=template&id=b6245778&scoped=true&"
import script from "./Salidas.vue?vue&type=script&lang=js&"
export * from "./Salidas.vue?vue&type=script&lang=js&"
import style0 from "./Salidas.vue?vue&type=style&index=0&id=b6245778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6245778",
  null
  
)

export default component.exports